<template>
    <div class="create-content">

        <div v-if="isdatapresent" class="loader">
                <v-progress-circular
                    :width="10"
                    :size="100"
                    color="green"
                    indeterminate
                ></v-progress-circular>
        </div>
        <!-- isdatapresent === false -->
        <div v-else>
        <div class="buttons-section flex">
            <!-- <div class="create-post-button flex pointer" @click="getImageOrVideoConfig('images')">
                <div class="image-section">
                    <img src="@/assets/MainDashboard/CreateContent/CreatePost.svg" alt="">
                </div>

                <div class="text">
                    <p class="--green --weight">Create a Post</p>
                    <small class="secondary-font">
                       Reach your targeted audience about
                        your new product or discounts
                    </small>
                </div>
            </div> -->

            <div class="create-poll-button flex pointer" @click="createPollDialog = true">
                <div class="image-section">
                    <img src="@/assets/MainDashboard/CreateContent/CreatePoll.svg" alt="">
                </div>

                <div class="text">
                    <p class="--weight" style="color: #3C89C9;">Create a Poll</p>
                    <small class="secondary-font">
                        Get your customer engaged with a
                        multiple choice options.
                    </small>
                </div>
            </div>

            <div class="create-poll-button flex pointer" @click="getImageOrVideoConfig('video')">
                <div class="image-section">
                    <img src="@/assets/MainDashboard/CreateContent/VerticalVideoUpload.svg" alt="">
                </div>

                <div class="text">
                    <p class="--weight" style="color: #9A5ACB;">Upload Videos</p>
                    <small class="secondary-font">
                        Share highly engaging vertical short
                        videos with your consumer (max size 35 mb)
                    </small>
                </div>
            </div>
        </div>
<p class="note"> <span style="color:red">*</span> Note : Now krishify support only videos posts</p>
        <div class="figures flex">
            <p class="my-0 --font"> {{ heading }} </p>

            <div class="flex" >
                <pagination :total="totalData" ref="paginationRef" @changePage="getContentList"/>
                <p :class="{'active' : !postType && !status}" class="my-0 pointer" @click="filterList('', '')">All Campaigns</p>
                <p :class="{'active' : postType === 'post'}" class="my-0 pointer" @click="filterList('post', '')">Posts</p>
                <p :class="{'active' : postType === 'poll'}" class="my-0 pointer" @click="filterList('poll', '')">Polls</p>
                <p :class="{'active' : postType === 'krishi_clips'}" class="my-0 pointer" @click="filterList('krishi_clips', '')">Videos</p>
                <p :class="{'active' : status === 'draft'}" class="my-0 pointer" @click="filterList('', 'draft')">Drafts</p>
                <p :class="{'active' : status === 'archive'}" class="my-0 pointer" @click="filterList('', 'archive')">Archived</p>
            </div>
        </div>
        <div class="create-content-card-section">
            <create-content-card 
                v-for="(item, index) in contentList" 
                :key="index" 
                :item="item" 
                @refresh="getContentList"
                @getDetails="getDetails"/>
        </div>

        <create-a-post 
            ref="createPostRef" 
            :dialog="createPostDialog"
            :type="postActionType" 
            @refreshList="getContentList" 
            @close="createPostDialog = false; postActionType = 'new'"/>

        <create-a-poll 
            ref="createPollRef"
            :dialog="createPollDialog" 
            @refreshList="getContentList" 
            @close="createPollDialog = false; pollActionType = 'new'"
            :type="pollActionType"/>
        
        <upload-video 
            ref="uploadVerticalVideoRef" 
            @refreshList="getContentList" 
            :dialog="verticalVideoDialog" 
            @close="verticalVideoDialog = false; videoActionType = 'new'"
            :type="videoActionType"/>
        
        <post-details-card ref="postCardRef" />

        <poll-details-card ref="pollCardRef" />

        <video-details-card ref="videoCardRef"/>     
        </div>

    </div>
  
</template>

<script>
import createContentCard from './components/create-content-card.vue'
import createPostModal from "./components/create-a-post.vue";
import createPollModal from "./components/create-a-poll.vue";
import postDetailsCard from "./components/post-card.vue";
import videoCardModal from "./components/video-post.vue";
import pollDetailsCard from "./components/poll-card.vue";
import uploadVideoModal from "./components/upload-vertical-videos.vue";
import pagination from "../Common/pagination.vue";
import accessToken from '../../../helpers/accessToken';
import API_URL from "../../../helpers/apiUrls"
import { eventBus } from '../../../main';
import menu from './components/menu.vue';
import methods from '../../../helpers/methods';
import MoengageEventGenerator from '../../../helpers/moengageEventGenerator';
export default {
    name : 'createContent',

    data() {
        return {
            heading : '',
            contentList : [],
            createPostDialog : false,
            createPollDialog : false,
            verticalVideoDialog : false,
            isdatapresent: false,
            viewPostDialog:false,
            postType : '',
            status : '',
            postDetailsDialog : true,
            postActionType : 'new',
            pollActionType : 'new',
            videoActionType : 'new',
            totalData : 0,
            page : 1,
            isdatapresent:false
        }
    },

    computed : {
        postDetails() {
            return this.$store.getters['createContentStore/GET_POST_DETAILS'];
        }
    },

    watch : {
        'postDetails.createPostDialog' : function(value) {
            if(value) {
                this.$refs.createPostRef.campaignName = this.postDetails.heading;
                this.$refs.createPostRef.description = this.postDetails.description;
                this.getImageOrVideoConfig('images');
            }
        }
    },

    created() {
         // window?.Moengage.add_unique_user_id(response.data.brand.id)
   MoengageEventGenerator('test',{'id' : 200})
    },

    mounted() {
        this.getContentList();
        
    },

    methods : {
        getContentList() {
            this.toggleLoader(true)
            this.isdatapresent = true;
            const successHandler = response => {
                if(response.status === 200) {
                    this.isdatapresent = false;
                    this.toggleLoader(false)
                    this.heading = response.data.header;
                    this.contentList = response.data.brand_post_details;
                    this.totalData = response.data.total_data;
                    setTimeout(() => {
                        this.isdatapresent=false
                    }, 1000);
                }
            }

            const errorHandler  = error => {
                this.toggleLoader(false);
                 this.isdatapresent=false;
                console.log(error.data);
            }

            const data = {
                page : this.$refs.paginationRef.page,
                data_per_page : 20,
                post_type : this.postType,
                post_status : this.status
            }

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID')
            } 

            this.requestGET(
                API_URL.content,
                data,
                headers,
                successHandler,
                errorHandler
            )
        },

        filterList(postType, status) {
            this.postType = postType;
            this.status = status
            this.getContentList();
        },

        getImageOrVideoConfig(type) {
            this.toggleLoader(true);
            const successHandler = response => {
                if(response.status === 200) {
                    if(type === 'images') {
                        this.createPostDialog = true;
                        this.$refs.createPostRef.bucketName = response.data.configs.brand_post_images_upload_config.bucket_name;
                        this.$refs.createPostRef.expiryTime = response.data.configs.brand_post_images_upload_config.expiry_time;
                        this.$refs.createPostRef.bucketPath = response.data.configs.brand_post_images_upload_config.bucket_path;
                        this.$refs.createPostRef.imageSelectionLimit = Number(response.data.configs.brand_post_images_upload_config.maximum_number_of_images);
                        eventBus.$emit('setFormIdentifier', response.data.configs.post_form_configs);
                    }
                    else {
                        this.verticalVideoDialog = true;
                        this.$refs.uploadVerticalVideoRef.bucketName = response.data.configs.brand_krishi_clips_video_upload_config.bucket_name;
                        this.$refs.uploadVerticalVideoRef.bucketPath = response.data.configs.brand_krishi_clips_video_upload_config.bucket_path;
                        this.$refs.uploadVerticalVideoRef.expiryTime = response.data.configs.brand_krishi_clips_video_upload_config.expiry_time;
                        this.$refs.uploadVerticalVideoRef.maxVideoDuration = response.data.configs.brand_krishi_clips_video_upload_config.max_video_duration_in_sec;
                        this.$refs.uploadVerticalVideoRef.uploadConfigs = response.data.configs.brand_krishi_clips_video_upload_config;
                        eventBus.$emit('setFormIdentifier', response.data.configs.clip_form_configs);
                    }
                    this.toggleLoader(false);
                }
            }

            const errorHandler = response => {
                this.showToast('Something went wrong internally!', 'error', 10000);
            }

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID') 
            }

            this.requestGET(
                API_URL.createContent__getImageOrVideoConfigs,
                {},
                headers,
                successHandler,
                errorHandler
            )
        },

        getDetails(data) {
            if(data.type === 'post')
                this.getPostDetails(data.id, data.action);
            else if(data.type === 'poll')
                this.getPollDetails(data.id);
            else
                this.getVideoDetails(data.id);
        },

        getPostDetails(ID, action) {
            const successHandler = response => {
                if(response.status === 200) {
                    this.$refs.createPostRef.campaignName = response.data.campaign_name;
                    this.$refs.createPostRef.description = response.data.detail.description;
                    this.$refs.createPostRef.imagePreviews = response.data.detail.images.map(image => {
                        return {
                            id : image.id,
                            url : image.image.original
                        }
                    });
                    this.$refs.createPostRef.postID = ID;
                    this.postActionType = 'edit';
                    this.getImageOrVideoConfig('images');

                    // FIGURE OUT A WAY TO OPEN THE FORM LIST MODAL DIRECTLY
                }
            }

            const errorHandler = error => {
                console.log(error);
                this.showToast("Something went wrong internally!", "error", 10000);
            }

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID') 
            }

            this.requestGET(
                `${API_URL.createContent__updateOrDelete}${ID}/post_update`,
                {},
                headers,
                successHandler,
                errorHandler
            )
        },

        getPollDetails(ID) {
            const successHandler = response => {
                if(response.status === 200) {
                    this.$refs.createPollRef.campaignName = response.data.campaign_name;
                    this.$refs.createPollRef.description = response.data.detail.text;
                    this.$refs.createPollRef.pollID = ID;
                    this.$refs.createPollRef.answers = response.data.detail.options.map(option => {
                        return {
                            index : (option.order + 9).toString(36).toUpperCase(),
                            text : option.text,
                            id : option.id
                        }
                    });
                    this.pollActionType = "edit";
                    this.createPollDialog = true;
                }
            }

            const errorHandler = error => {
                console.log(error);
                this.showToast("Something went wrong internally!", "error", 10000);
            }

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID') 
            }

            this.requestGET(
                `${API_URL.createContent__updateOrDelete}${ID}/poll_update`,
                {},
                headers,
                successHandler,
                errorHandler
            )
        },

        getVideoDetails(ID) {
            const successHandler = response => {
                if(response.status === 200) {
                    console.log(response.data);
                    this.$refs.uploadVerticalVideoRef.campaignName = response.data.campaign_name;
                    this.$refs.uploadVerticalVideoRef.description = response.data.detail.description;
                    this.$refs.uploadVerticalVideoRef.videoIDForEdit = ID;
                    this.$refs.uploadVerticalVideoRef.videoID = response.data.detail.video.id;
                    this.$refs.uploadVerticalVideoRef.videoPreview = response.data.detail.video.mp4_src_url;
                    this.videoActionType = 'edit';
                    this.getImageOrVideoConfig('video');
                }
            }

            const errorHandler = error => {
                console.log(error);
                this.showToast("Something went wrong internally!", "error", 10000);
            }

            const headers = {
                'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                'BRAND-ID' : localStorage.getItem('Brand-ID') 
            }

            this.requestGET(
                `${API_URL.createContent__updateOrDelete}${ID}/krishi_clip_update`,
                {},
                headers,
                successHandler,
                errorHandler
            )
        }
    },

    components : {
        'create-content-card' : createContentCard,
        "create-a-post" : createPostModal,
        "create-a-poll" : createPollModal,
        "upload-video" : uploadVideoModal,
        "post-details-card" : postDetailsCard,
        "poll-details-card" : pollDetailsCard,
        "video-details-card":videoCardModal,
        "pagination" : pagination,
        "menu":menu
    }
}
</script>

<style lang="scss" scoped>
.loader{
    width: 100%;
    height: 90vh;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content : center;
}
.buttons-section {
    p {
        margin: 0;
    }
    justify-content: space-between;
    align-items: stretch;
    height:100px
}

.buttons-section > div {
    background-color: white;
    justify-content: space-between;
    width: 49.5%;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 7px;
    padding: 20px 15px;
    transition: 0.5s;
    //height: 130px;
}

.buttons-section > div:nth-child(1):hover {
    background: rgba(96, 191, 129, 0.07);
}

.buttons-section > div:nth-child(2):hover {
    background: rgba(77, 147, 206, 0.07);
}

.buttons-section > div:nth-child(3):hover {
    background: #c6c3c9;
}

.image-section {
    width: 20%;
} 
.loader{
    width: 100%;
    height: 90vh;
    margin: 0px auto;
    display: flex;
    align-items: center;
    justify-content : center;
}

.image-section img {
    width: 100%;
    height: 60px !important;
}

.text {
    width: 60%;
    margin: 0 10px 0;
}

.add-icon {
    width: 10%;
    border-radius: 50%;
    width: 50px;
    height: 50px;
}

.add-icon img{
    width: 20px;
}

.figures {
    justify-content: space-between;
    margin-top: 25px;
}

.figures > div p {
    font-size: 0.9rem;
    margin-left: 10px;
    color: #A6ACA9;

    &.active {
        color: var(--primary-font);
    }
}

.note{
font-size: 14px;
margin-top: 6px;
}

@media all and (min-width : 1400px) {

    .image-section {
        width: 20%;
    }

    .text {
        width: 70%;
    }
}

</style>